import type { Sendable } from '@/interfaces/Sendable'
import { ProjectsService } from '@/api/client'
import { type Error } from '@/types/error'
import { DateTime } from 'luxon'

type TProjectDateCompletionMeta = {
  transmitted: boolean
  transmitted_at: string
  error_log: Error[]
}

export type TDehydratedProjectDateCompletion = {
  meta: TProjectDateCompletionMeta
  completed_date: string
  project_date_id: number
  type: 'project_date_completion'
}

export class ProjectDateCompletion implements Sendable {
  readonly type = 'project_date_completion'
  meta: TProjectDateCompletionMeta
  project_date_id: number
  completed_date: string | null

  constructor(
    project_date_id: number,
    completed_date?: string | null,
    meta?: TProjectDateCompletionMeta,
  ) {
    if (meta) {
      this.meta = meta
    } else {
      this.meta = {
        transmitted: false,
        transmitted_at: DateTime.now().toISO(),
        error_log: [],
      }
    }
    if (completed_date !== undefined) {
      this.completed_date = completed_date
    } else {
      this.completed_date = DateTime.now().toISO()
    }
    this.project_date_id = project_date_id
  }

  send(): Promise<{
    error: false | Error
  }> {
    return new Promise(async (resolve, reject) => {
      const response = await ProjectsService.completeProjectDate(
        this.project_date_id,
        {
          completed_date: this.completed_date,
        },
      )
      if (response.error) {
        reject(response.error)
        return
      }
      resolve({ error: false })
    })
  }
  cleanup() {
    return true
  }
  isReady() {
    return true
  }

  static fromJSON(
    dehydratedProjectCompletion: TDehydratedProjectDateCompletion,
  ) {
    return new ProjectDateCompletion(
      dehydratedProjectCompletion.project_date_id,
      dehydratedProjectCompletion.completed_date,
      dehydratedProjectCompletion.meta,
    )
  }
  toJSON(): TDehydratedProjectDateCompletion {
    return {
      type: this.type,
      meta: this.meta,
      completed_date: this.completed_date ?? '',
      project_date_id: this.project_date_id,
    }
  }
}
